// extracted by mini-css-extract-plugin
export default {"formArea":"ContactForm_formArea__N5EWu","alertArea":"ContactForm_alertArea__KYdao","btnSendMsg":"ContactForm_btnSendMsg__FwlaV"};